/**
 * Returns true when every cased letter in the string is plain a-z / A-Z.
 * Digits and symbols (e.g. ! *) are allowed; language-specific letters (ä, ã, æ, …) are not.
 */
export function hasOnlyAsciiLetters(password: string): boolean {
    for (let i = 0; i < password.length; i++) {
        const c = password.charAt(i);
        if ((c >= 'a' && c <= 'z') || (c >= 'A' && c <= 'Z')) {
            continue;
        }
        if (c.toLowerCase() !== c.toUpperCase()) {
            return false;
        }
    }
    return true;
}

export const PASSWORD_NO_LANGUAGE_SPECIFIC_LETTERS_KEY = 'password.not language specific letters';
